(function () {
  if (window.__mtInit) return;
  window.__mtInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('mt-visible'); observer.unobserve(e.target); }
    });
  }, { threshold: 0.15 }) : null;

  function initReveals(root) {
    root.querySelectorAll('.mt-reveal, .mt-pasos__grid').forEach(function (el) {
      if (el.dataset.mtInit) return; el.dataset.mtInit = '1';
      if (!observer || reduce) el.classList.add('mt-visible'); else observer.observe(el);
    });
  }

  // Héroe: la tarjeta se inclina hacia el cursor (#5)
  function initTilt(root) {
    root.querySelectorAll('[data-mt-tilt]').forEach(function (escena) {
      if (escena.dataset.mtTiltInit) return; escena.dataset.mtTiltInit = '1';
      var tarjeta = escena.querySelector('.mt-hero__tarjeta');
      var max = parseFloat(escena.dataset.mtTilt) || 8;
      if (!tarjeta || reduce || window.matchMedia('(hover: none)').matches) return;
      escena.addEventListener('mousemove', function (ev) {
        var r = escena.getBoundingClientRect();
        var x = (ev.clientX - r.left) / r.width - 0.5;
        var y = (ev.clientY - r.top) / r.height - 0.5;
        tarjeta.style.transform = 'rotateY(' + (x * max * 2) + 'deg) rotateX(' + (-y * max * 2) + 'deg)';
      });
      escena.addEventListener('mouseleave', function () { tarjeta.style.transform = ''; });
    });
  }

  // Hotspots: punto <-> tarjeta de la lista (#17)
  function initHotspots(root) {
    root.querySelectorAll('[data-mt-hot]').forEach(function (sec) {
      if (sec.dataset.mtInit) return; sec.dataset.mtInit = '1';
      var puntos = sec.querySelectorAll('[data-mt-punto]');
      var items = sec.querySelectorAll('[data-mt-item]');
      function activar(i) {
        puntos.forEach(function (p) { p.classList.toggle('is-activo', p.dataset.mtPunto === i); });
        items.forEach(function (it) { it.classList.toggle('is-activo', it.dataset.mtItem === i); });
      }
      puntos.forEach(function (p) {
        p.addEventListener('click', function () {
          activar(p.dataset.mtPunto);
          var it = sec.querySelector('[data-mt-item="' + p.dataset.mtPunto + '"]');
          if (it && window.innerWidth < 990) it.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
        p.addEventListener('mouseenter', function () { activar(p.dataset.mtPunto); });
      });
      items.forEach(function (it) {
        it.addEventListener('click', function () { activar(it.dataset.mtItem); });
        it.addEventListener('mouseenter', function () { activar(it.dataset.mtItem); });
      });
      if (items[0]) activar(items[0].dataset.mtItem);
    });
  }

  // FAQ desplegable (#80)
  function initFaq(root) {
    root.querySelectorAll('.mt-faq__item').forEach(function (item) {
      if (item.dataset.mtInit) return; item.dataset.mtInit = '1';
      var btn = item.querySelector('.mt-faq__pregunta');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var abierto = item.classList.toggle('is-abierto');
        btn.setAttribute('aria-expanded', abierto ? 'true' : 'false');
      });
    });
  }

  // Página de producto: galería, variantes y cantidad
  function initProducto(root) {
    root.querySelectorAll('[data-mt-producto]').forEach(function (sec) {
      if (sec.dataset.mtInit) return; sec.dataset.mtInit = '1';
      var principal = sec.querySelector('.mt-prod__principal img');
      sec.querySelectorAll('.mt-prod__mini').forEach(function (mini) {
        mini.addEventListener('click', function () {
          if (principal) { principal.src = mini.dataset.src; principal.alt = mini.dataset.alt || ''; }
          sec.querySelectorAll('.mt-prod__mini').forEach(function (m) { m.classList.toggle('is-activa', m === mini); });
        });
      });

      var cant = sec.querySelector('[data-mt-cantidad]');
      if (cant) {
        sec.querySelectorAll('[data-mt-cant]').forEach(function (b) {
          b.addEventListener('click', function () {
            var v = Math.max(1, (parseInt(cant.value, 10) || 1) + parseInt(b.dataset.mtCant, 10));
            cant.value = v;
          });
        });
      }

      var datos = sec.querySelector('[data-mt-variantes]');
      if (!datos) return;
      var variantes = JSON.parse(datos.textContent);
      var selects = sec.querySelectorAll('[data-mt-opcion]');
      var inputId = sec.querySelector('input[name="id"]');
      var precio = sec.querySelector('[data-mt-precio]');
      var tachado = sec.querySelector('[data-mt-tachado]');
      var boton = sec.querySelector('[data-mt-anadir]');
      var textoBoton = boton ? boton.dataset.texto : '';
      var textoAgotado = boton ? boton.dataset.agotado : '';
      var formato = sec.dataset.mtMoneda || '{{amount}}';
      function dinero(c) {
        var n = (c / 100).toFixed(2);
        return formato.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, n.replace('.', ','))
          .replace(/\{\{\s*amount\s*\}\}/, n)
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(c / 100));
      }
      function actualizar() {
        var elegidas = Array.prototype.map.call(selects, function (s) { return s.value; });
        var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === elegidas[i]; }); });
        if (!v) { if (boton) { boton.disabled = true; boton.textContent = textoAgotado; } return; }
        inputId.value = v.id;
        if (precio) precio.textContent = dinero(v.price);
        if (tachado) {
          if (v.compare_at_price && v.compare_at_price > v.price) { tachado.textContent = dinero(v.compare_at_price); tachado.hidden = false; }
          else tachado.hidden = true;
        }
        if (boton) { boton.disabled = !v.available; boton.textContent = v.available ? textoBoton : textoAgotado; }
        if (v.featured_image && principal) principal.src = v.featured_image;
      }
      selects.forEach(function (s) { s.addEventListener('change', actualizar); });
    });
  }

  function initTodo(e) {
    var root = (e && e.target && e.target.querySelectorAll) ? e.target : document;
    initReveals(root); initTilt(root); initHotspots(root); initFaq(root); initProducto(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTodo);
  else initTodo();
  document.addEventListener('shopify:section:load', initTodo);
})();
